import './lib/ahoy';

export const initTrackClicks = () => {
  try {
    ahoy.trackClicks()
  } catch (e) {
    console.error(e)
  }
};
